import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen, CalendarDays, ShoppingCart, Pill, Sunrise } from 'lucide-react';
const deliverables = [{
  icon: <BookOpen size={24} data-id="element-164" />,
  title: 'Guía Principal "Metabolismo 40+ Reset"',
  desc: 'El paso a paso clínico explicado de forma sencilla.'
}, {
  icon: <CalendarDays size={24} data-id="element-165" />,
  title: 'Protocolo de 21 Días',
  desc: 'Calendario diario de comidas y hábitos para resetear tu quema de grasa.'
}, {
  icon: <ShoppingCart size={24} data-id="element-166" />,
  title: 'Lista de Compras USA (Walmart/Costco/Target)',
  desc: 'Los productos exactos para alimentar tus hormonas sin gastar una fortuna.'
}, {
  icon: <Pill size={24} data-id="element-167" />,
  title: 'Hoja de Ruta de Suplementos',
  desc: 'Qué minerales realmente necesitas para dormir y desinflamarte (y cuáles son tirar el dinero).'
}, {
  icon: <Sunrise size={24} data-id="element-168" />,
  title: 'Checklist de hábitos matutinos',
  desc: '5 minutos para activar tu metabolismo al despertar.'
}];
export function WhatYouGet() {
  return <section className="py-20 px-6 md:px-12 bg-white" data-id="element-169">
      <div className="max-w-4xl mx-auto" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-172">
            Lo que obtienes hoy
          </h2>
          <p className="text-lg text-gray-600" data-id="element-173">
            Todo lo que necesitas para recuperar el control, sin complicaciones.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-174">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-cream p-6 rounded-2xl flex items-center gap-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-175">
              <div className="bg-coral text-white p-3 rounded-full shrink-0" data-id="element-176">
                {item.icon}
              </div>
              <div data-id="element-177">
                <h3 className="font-bold text-xl text-charcoal" data-id="element-178">
                  {item.title}
                </h3>
                <p className="text-gray-600 mt-1" data-id="element-179">{item.desc}</p>
              </div>
              <div className="ml-auto hidden md:block text-sage" data-id="element-180">
                <CheckCircle2 size={28} data-id="element-181" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}